import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { HeaderRepository } from '../../../@core/repositories/header.repository';
import { HttpService } from '@shared/services/http/http.service';
import { HeaderLogoDto, HeaderLogoResponseDto } from '@data/data/models/header-logo.dto';

@Injectable({
  providedIn: 'root'
})
export class HeaderAdapter extends HeaderRepository {
  http = inject(HttpService);
  url = environment.drupalApi;

  getHeaderLogo(): Observable<HeaderLogoDto[]> {
    return this.http.get<HeaderLogoResponseDto>(`${environment.serviceApi}paths-header-logo`, {}).pipe(
      map((resp: HeaderLogoResponseDto) => resp.data)
    );
  }

}